<template>
  <v-container
    fluid
  >
    <v-row
      no-gutters
    >
      <v-col
        class="mx-0"
      >
        <div
          class="d-flex flex-wrap align-center"
        >
          <div
            class="d-flex ml-n3 align-center"
          >
            <v-btn
              outlined
              class="common-cancel-btn header-back-btn"
              link
              :to="{name: 'comparison.summary'}"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
              戻る
            </v-btn>
          </div>
          <div
            class="d-flex pl-5 align-center comparisons-range"
          >
            <ComparisonRange
              :from="userBaseComparisons.date_from"
              :to="userBaseComparisons.date_to"
              :limit-calendar-months-count="12"
              :disable-dates-in-future-months="true"
              @update="updateComparisonRange"
            >
            </ComparisonRange>
          </div>
          <div class="d-flex spacer"></div>
          <div class="d-flex align-center">
            <div class="d-inline-flex align-center white--text">
              <div class="d-block">{{ userBaseComparisons.store_name }}</div>
            </div>
            <ModalSingleSelect
              title="店舗選択"
              icon="storefront-outline"
              :lists="companyStores"
              :id="userBaseComparisons.store_id"
              label-field="store_name"
              @select="selectStore"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <StatusFrame
          id="sales"
          :status="sales.frame_status"
        >
          <!-- 売上(税込) -->
          <!-- 横棒グラフ -->
          <apexchart
            ref="sales"
            type="bar"
            height="160"
            :options="sales.chartOptions"
            :series="sales.series"
           />
          <!-- ./横棒グラフ -->
          <!-- ./売上(税込) -->
        </StatusFrame>
      </v-col>
    </v-row>
    <!-- 関連データ -->
    <v-row>
      <v-col>
        <div
          class="text-h6"
        >
          関連データ
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <StatusFrame
          id="customer"
          :status="customer.frame_status"
        >
          <!-- 客数 -->
          <!-- 横棒グラフ -->
          <apexchart
            ref="customer"
            type="bar"
            height="160"
            :options="customer.chartOptions"
            :series="customer.series"
          />
          <!-- ./横棒グラフ -->
          <!-- ./客数 -->
        </StatusFrame>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <StatusFrame
          id="unit_price"
          :status="unitPrice.frame_status"
        >
          <!-- 客単価（税込） -->
          <!-- 横棒グラフ -->
          <apexchart
            ref="unitPrice"
            type="bar"
            height="160"
            :options="unitPrice.chartOptions"
            :series="unitPrice.series"
          />
          <!-- ./横棒グラフ -->
          <!-- ./客単価（税込） -->
        </StatusFrame>
      </v-col>
    </v-row>
    <!-- ./関連データ -->
    <!-- 収益力データ -->
    <v-row>
      <v-col>
        <div
          class="text-h6"
        >
          収益力データ
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <StatusFrame
          id="rotation"
          :status="rotation.frame_status"
        >
          <!-- 回転数／日 -->
          <!-- 横棒グラフ -->
          <apexchart
            ref="rotation"
            type="bar"
            height="160"
            :options="rotation.chartOptions"
            :series="rotation.series"
          />
          <!-- ./横棒グラフ -->
          <!-- ./回転数／日 -->
        </StatusFrame>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <!-- 平均オーダー数 -->
        <StatusFrame
          id="order_count"
          :status="orderCount.frame_status"
        >
          <!-- 横棒グラフ -->
          <apexchart
            ref="orderCount"
            type="bar"
            height="160"
            :options="orderCount.chartOptions"
            :series="orderCount.series"
          />
          <!-- ./横棒グラフ -->
        </StatusFrame>
        <!-- ./平均オーダー数 -->
      </v-col>
    </v-row>
    <!-- ./収益力データ -->
    <!-- 利便性データ -->
    <v-row>
      <v-col>
        <div
          class="text-h6"
        >
          利便性データ
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <!-- テイクアウト比率 -->
        <StatusFrame
          id="takeout"
          :status="takeout.frame_status"
        >
          <!-- 帯グラフ -->
          <apexchart
            ref="takeout"
            type="bar"
            height="180"
            :options="takeout.chartOptions"
            :series="takeout.series"
          />
          <!-- ./帯グラフ -->
        </StatusFrame>
        <!-- ./テイクアウト比率 -->
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <!-- 支払い種別比率 -->
        <StatusFrame
          id="payment"
          :status="payment.frame_status"
        >
          <!-- 帯グラフ -->
          <apexchart
            ref="payment"
            type="bar"
            height="180"
            :options="payment.chartOptions"
            :series="payment.series"
          />
          <!-- ./帯グラフ -->
        </StatusFrame>
        <!-- ./支払い種別比率 -->
      </v-col>
    </v-row>
    <!-- ./利便性データ -->
    <!-- マーケティングデータ -->
    <v-row>
      <v-col>
        <div
          class="text-h6"
        >
          マーケティングデータ
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <!-- 男女比率 -->
        <StatusFrame
          id="gender"
          :status="gender.frame_status"
        >
          <!-- 帯グラフ -->
          <apexchart
            ref="gender"
            type="bar"
            height="180"
            :options="gender.chartOptions"
            :series="gender.series"
          />
          <!-- ./帯グラフ -->
        </StatusFrame>
        <!-- ./男女比率 -->
      </v-col>
    </v-row>
    <!-- ./マーケティングデータ -->
  </v-container>
</template>

<script>
import { install } from 'resize-observer'
if (!window.ResizeObserver) install()
import 'eligrey-classlist-js-polyfill'
import VueApexCharts from 'vue-apexcharts'
import StatusFrame from '@/views/components/utility/StatusFrame'
import ComparisonRange from '@/views/components/utility/DatePickerRange'
import ModalSingleSelect from '@/views/components/utility/ModalSingleSelect'
import {
  checkComparison,
  checkDeadline,
  clearData,
  DATA_TYPES,
  SAVE_STORE_GRAPH, SAVE_STORE_SUMMARY,
  saveToStore,
  searchStore,
  sendGetParallelApi
} from "../../../util";

export default {
  name: 'ComparisonGraph',
  components: {
    'apexchart': VueApexCharts,
    StatusFrame,
    ComparisonRange,
    ModalSingleSelect,
  },
  data () {
    return {
      hash: this.$route.hash,
      userBaseComparisons: {
        store_id: null,
        store_name: null,
        date_from: null,
        date_to: null,
        industry_id: null,
        corporation_estimate_sales: null,
        store_estimate_sales: null,
        seat_num: null,
      },
      companyStores: [],
      baseChartOptions: {
        chart: {
          width: '100%',
          animations: {
            enabled: false,
          }
        },
        title: {
          align: 'left'
        },
        plotOptions: {
          bar: {
            barHeight: '95%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
            colors: {
              backgroundBarColors: ['#f3f3f3', '#f3f3f3', '#f3f3f3'],
              backgroundBarOpacity: 0.5,
            },
          },
        },
        colors: ['#4682b4', '#ffd700', '#f4a460', '#d3d3d3'],
        dataLabels: {
          enabled: true,
          textAnchor: 'end',
          style: {
            fontSize: '12px',
            colors: ['#000'],
          },
        },
        tooltip: {
          enabled: false,
        },
        xaxis: {
          categories: [
            '自店舗', '全体', '上位', '下位'
          ],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              fontWeight: 600,
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#b0c4de', '#fffacd', '#f5deb3', '#f5f5f5'],
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          offsetX: 0,
          offsetY: -20,
          markers: {
            width: 0,
          },
          itemMargin: {
            horizontal: 2
          }
        },
        grid: {
          show: false,
          padding: {
            right: 0,
            bottom: 0,
            left: 0
          },
        },
        noData: {
          text: '表示データがありません',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            fontSize: '20px',
            color: "#000",
          }
        }
      },
      sales: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            toolbar: {
              offsetY: 150,
              export: {
                csv: {
                  filename: '売上'
                },
                png: {
                  filename: '売上'
                }
              },
            }
          },
          title: {
            text: '売上(税込)',
          },
          dataLabels: {
            formatter: (val) => {
              if (val === null) return ''
              return String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円'
            },
          },
          legend: {
            show: false,
          },
          grid: {
            show: false,
            padding: {
              top: -25,
            },
          },
        },
      },
      customer: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            toolbar: {
              offsetY: 150,
              export: {
                csv: {
                  filename: '客数'
                },
                png: {
                  filename: '客数'
                }
              },
            }
          },
          title: {
            text: '客数',
          },
          dataLabels: {
            formatter: (val) => {
              if (val === null) return ''
              return String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '人'
            },
          },
          legend: {
            show: false,
          },
          grid: {
            padding: {
              top: -25,
            },
          },
        },
      },
      unitPrice: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            toolbar: {
              offsetY: 150,
              export: {
                csv: {
                  filename: '客単価（税込）'
                },
                png: {
                  filename: '客単価（税込）'
                }
              },
            },
          },
          title: {
            text: '客単価（税込）',
          },
          dataLabels: {
            formatter: (val, opt) => {
              let label = ''
              if (val !== null) {
                label = String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円';
              }
              let diff = null
              if (this.unitPrice.series[opt.seriesIndex] !== undefined && this.unitPrice.series[opt.seriesIndex].diff !== undefined) {
                diff = this.unitPrice.series[opt.seriesIndex].diff
                if (Array.isArray(diff) && diff.length >= opt.dataPointIndex) {
                  diff = diff[opt.dataPointIndex]
                }
              }
              if (diff !== null) {
                const diffLabel = String(diff).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円';
                label = `${label} (${diffLabel})`
              }
              return label
            }
          },
          legend: {
            show: false,
          },
          grid: {
            padding: {
              top: -25,
            },
          },
        },
      },
      rotation: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            toolbar: {
              offsetY: 150,
              export: {
                csv: {
                  filename: '回転数／日'
                },
                png: {
                  filename: '回転数／日'
                }
              },
            },
          },
          title: {
            text: '回転数／日',
          },
          dataLabels: {
            formatter: (val) => {
              if (val === null) return ''
              return String(val) + '回'
            }
          },
          legend: {
            show: false,
          },
          grid: {
            padding: {
              top: -25,
            },
          },
        },
      },
      orderCount: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            toolbar: {
              offsetY: 150,
              export: {
                csv: {
                  filename: '平均オーダー数'
                },
                png: {
                  filename: '平均オーダー数'
                }
              },
            },
          },
          title: {
            text: '平均オーダー数',
          },
          dataLabels: {
            formatter: (val) => {
              if (val === null) return ''
              return String(val) + '回'
            }
          },
          legend: {
            show: false,
          },
          grid: {
            padding: {
              top: -25,
            },
          },
        },
      },
      takeout: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            type: 'bar',
            width: '100%',
            stacked: true,
            stackType: '100%',
            toolbar: {
              offsetY: 170,
              export: {
                csv: {
                  filename: 'テイクアウト比率'
                },
                png: {
                  filename: 'テイクアウト比率'
                }
              },
            }
          },
          title: {
            text: 'テイクアウト比率',
            align: 'left',
          },
          plotOptions: {
            bar: {
              distributed: true,
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: (val) => {
                if (val === null) return ''
                return String(val) + '件'
              }
            },
            marker: {
              show: false,
            },
          },
          legend: {
            show: true,
          },
          grid: {
            padding: {
              top: -30,
            },
          },
        },
      },
      payment: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            stacked: true,
            stackType: '100%',
            toolbar: {
              offsetY: 170,
              export: {
                csv: {
                  filename: '支払い種別比率'
                },
                png: {
                  filename: '支払い種別比率'
                }
              },
            }
          },
          title: {
            text: '支払い種別比率',
          },
          plotOptions: {
            bar: {
              distributed: true,
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: (val) => {
                if (val === null) return ''
                return String(val) + '件'
              },
            },
            marker: {
              show: false,
            },
          },
          legend: {
            show: true,
          },
          grid: {
            padding: {
              top: -30,
            },
          },
        },
      },
      gender: {
        series: [],
        frame_status: 0,
        chartOptions: {
          chart: {
            stacked: true,
            stackType: '100%',
            toolbar: {
              offsetY: 170,
              export: {
                csv: {
                  filename: '男女比率'
                },
                png: {
                  filename: '男女比率'
                }
              },
            }
          },
          title: {
            text: '男女比率',
          },
          plotOptions: {
            bar: {
              distributed: true,
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: (val) => {
                if (val === null) return ''
                return String(val) + '件'
              },
            },
            marker: {
              show: false,
            },
          },
          legend: {
            show: true,
          },
          grid: {
            padding: {
              top: -30,
            },
          },
        },
      },
    }
  },
  async beforeRouteEnter(to, from, next) {
    await checkComparison(function(result) {
      if (result) {
        next()
      } else {
        next('/comparison/base')
      }
    });
  },
  mounted () {
    this.initialize()
    this.$nextTick(function () {
      this.scrollToAnchorPoint()
    })
  },
  methods: {
    scrollToAnchorPoint() {
      // 描画完了を待って、ハッシュタグの位置にスクロール
      if (this.hash) {
        const anchorName = this.hash.replace('#', '')
        const el = document.getElementById(anchorName)
        if (el !== undefined) {
          el.scrollIntoView(true)
          // now account for fixed header
          const scrolledY = window.scrollY;
          if(scrolledY){
            // ヘッダ部分戻る(仮に固定値)
            window.scroll(0, scrolledY - 65);
          }
        }
      }
    },
    initialize () {
      this.getBaseApi()
      this.initializeChartOptions()
    },
    getBaseApi() {
      const apis = [
        // url : callback
        {url: '/target', params: this.userBaseComparisons, callback: this.getCompanyStores},
      ];
      if (this.$store.getters["comparison/saveStatus"]) {
        // 比較基準が保存されていたら設定する
        this.userBaseComparisons.date_from = this.$store.getters["comparison/date_from"]
        this.userBaseComparisons.date_to = this.$store.getters["comparison/date_to"]
        this.userBaseComparisons.store_id = this.$store.getters["comparison/store_id"]
        this.userBaseComparisons.store_name = this.$store.getters["comparison/store_name"]
        this.userBaseComparisons.seat_num = this.$store.getters["comparison/seat_num"]
        this.userBaseComparisons.industry_id = this.$store.getters["comparison/industry_id"]
        // サマリ/グラフ間を移動する前に、期間、店舗を変更した時
        if (this.$store.getters["comparison/changeStatus"]) {
          this.getGraph()
        } else {
          let filter = {
            from: this.userBaseComparisons.date_from,
            to: this.userBaseComparisons.date_to,
            store_id: this.userBaseComparisons.store_id,
            type: DATA_TYPES.SALES,
          }
          checkDeadline(SAVE_STORE_GRAPH,filter,this.checkDate)
        }
        this.$store.dispatch('comparison/setChangeStatus', false);
      } else {
        apis.push({url:  '/comparison', params: this.userBaseComparisons, callback: this.getUserBaseComparisons});
      }
      sendGetParallelApi(apis)
    },
    getGraph() {
      const apis = [
        // url : callback
        {url: '/graph/sales', params: this.userBaseComparisons, callback : this.setSalesData},
        {url: '/graph/customerCount', params: this.userBaseComparisons, callback : this.setCustomer},
        {url: '/graph/customerUnitPrice', params: this.userBaseComparisons, callback : this.setUnitPrice},
        {url: '/graph/customerRotation', params: this.userBaseComparisons, callback : this.setRotation},
        {url: '/graph/orderAverage', params: this.userBaseComparisons, callback : this.setOrderCount},
        {url: '/graph/takeoutRate', params: this.userBaseComparisons, callback : this.setTakeoutRate},
        {url: '/graph/paymentTypeRate', params: this.userBaseComparisons, callback : this.setPayment},
        {url: '/graph/genderRate', params: this.userBaseComparisons, callback : this.setGender},
      ];
      sendGetParallelApi(apis);
    },
    getUserBaseComparisons (response) {
      // APIで比較基準設定を取得する
      if (this.checkResponse(response)) {
        let data = response.data.data;
        this.userBaseComparisons.store_id = data.store_id
        this.userBaseComparisons.store_name = data.store_name
        this.userBaseComparisons.industry_id = data.industry_id
        this.userBaseComparisons.seat_num = data.seat_num
        let now = new Date();
        let yearMonth = now.getFullYear() + '-' + ('00' + (now.getMonth() +1)).slice(-2) + '-'
        // 月初
        now.setDate(1)
        let firstDate = yearMonth + ('00' + now.getDate()).slice(-2)
        // 月末
        now.setMonth(now.getMonth() + 1);
        now.setDate(0);
        let lastDate = yearMonth + ('00' + now.getDate()).slice(-2)
        // 日付のデフォルトを設定
        this.userBaseComparisons.date_from = firstDate
        this.userBaseComparisons.date_to = lastDate
        // 比較基準をstoreに登録
        this.$store.dispatch('comparison/save', this.userBaseComparisons);
        this.$store.dispatch('comparison/setIsComparisonStatus', true)
        // 初期表示で比較基準の取得後、サマリ取得
        this.getGraph()
      } else {
        this.$store.dispatch('comparison/setIsComparisonStatus', false)
        // 比較基準が取得できない場合は、比較基準の設定ページへ
        this.$router.push('/comparison/base')
      }
      // todo:: 比較期間は、要検討(storeに保存されていたらstore参照、storeが空ならAPIのresponseを参照する？)
    },
    getCompanyStores (response) {
      if (this.checkResponse(response)) {
        this.companyStores = response.data.data;
      }
    },
    setSalesData(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getHorizontalResponseData(data)
        this.sales.series = this.convertToChartSeries(series)
        this.sales.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.sales.updateSeries(this.sales.series)
        let saveData = this.setIndexDBData(DATA_TYPES.SALES, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setCustomer(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getHorizontalResponseData(data)
        this.customer.series = this.convertToChartSeries(series)
        this.customer.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.customer.updateSeries(this.customer.series)
        let saveData = this.setIndexDBData(DATA_TYPES.CUSTOMER, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setUnitPrice(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getHorizontalResponseData(data)
        this.unitPrice.series = this.convertToChartSeries(series)
        this.unitPrice.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.unitPrice.updateSeries(this.unitPrice.series)
        let saveData = this.setIndexDBData(DATA_TYPES.UNIT_PRICE, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setRotation(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getHorizontalResponseData(data)
        this.rotation.series = this.convertToChartSeries(series)
        this.rotation.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.rotation.updateSeries(this.rotation.series)
        let saveData = this.setIndexDBData(DATA_TYPES.ROTATION, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setOrderCount(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getHorizontalResponseData(data)
        this.orderCount.series = this.convertToChartSeries(series)
        this.orderCount.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.orderCount.updateSeries(this.orderCount.series)
        let saveData = this.setIndexDBData(DATA_TYPES.ORDER, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setTakeoutRate(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getBandResponseData(data)
        this.takeout.series = this.convertToChartSeries(series)
        this.takeout.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.takeout.updateSeries(this.takeout.series)
        let saveData = this.setIndexDBData(DATA_TYPES.TAKEOUT, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setPayment(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getBandResponseData(data)
        this.payment.series = this.convertToChartSeries(series)
        this.payment.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.payment.updateSeries(this.payment.series)
        let saveData = this.setIndexDBData(DATA_TYPES.PAYMENT, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setGender(response) {
      if (this.checkResponse(response)) {
        // this.setGraphData(this.sales, data);
        let data = response.data.data
        // 取得データに問題なければ、レスポンスをグラフ用の形式に変換する
        const {series, frame_status, value} = this.getBandResponseData(data)
        this.gender.series = this.convertToChartSeries(series)
        this.gender.frame_status = frame_status

        // グラフデータの更新を通知
        this.$refs.gender.updateSeries(this.gender.series)
        let saveData = this.setIndexDBData(DATA_TYPES.GENDER, series, value, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_GRAPH, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    initializeChartOptions () {
      // 各グラフのオプションを設定する（サンプルとして共通設定を準備し、グラフ毎の設定とマージ）
      let baseChartOptions = {...this.baseChartOptions}
      this.sales.chartOptions = {...this.sales.chartOptions, ...baseChartOptions}
      this.customer.chartOptions = {...this.sales.chartOptions, ...baseChartOptions}
      this.unitPrice.chartOptions = {...this.unitPrice.chartOptions, ...baseChartOptions}
      this.rotation.chartOptions = {...this.rotation.chartOptions, ...baseChartOptions}
      this.orderCount.chartOptions = {...this.orderCount.chartOptions, ...baseChartOptions}
      this.takeout.chartOptions = {...this.takeout.chartOptions, ...baseChartOptions}
      this.payment.chartOptions = {...this.payment.chartOptions, ...baseChartOptions}
      this.gender.chartOptions = {...this.gender.chartOptions, ...baseChartOptions}
    },

    convertToChartSeries (rows) {
      if (!Array.isArray(rows) || rows.length <= 0) return []
      let _series = []
      rows.forEach((row) => {
        let _tmp = {
          'name': row.name,
          'data': this.convertToChartData(row),
          'diff':('diff' in row) ? this.convertToChartData(row.diff) : null
        }
        _series.push(_tmp)
      })
      return _series
    },
    convertToChartData (row) {
      const {self = null, all = null, high = null, low = null} = row
      return [
        self,
        all,
        high,
        low,
      ]
    },
    getHorizontalResponseData (data) {
      const {horizontal = null, frame_status = 0, value = null} = {...data}
      let series = []
      if (horizontal !== null) {
        series.push(horizontal)
      }
      return {series, frame_status, value}
    },
    getBandResponseData (data) {
      const {band = null, frame_status = 0, value = null} = {...data}
      let series = []
      if (band !== null) {
        series = band
      }
      return {series, frame_status, value}
    },
    updateComparisonRange (evt) {
      // カレンダーで期間が変更されたので、プロパティ書き換え
      this.userBaseComparisons.date_from = evt.from
      this.userBaseComparisons.date_to = evt.to

      // 指定範囲が変更されたので、再度APIをコールし表示データの再取得を行う
      // or
      // storeに書き込んで、再遷移？
      // 比較基準をstoreに登録
      this.$store.dispatch('comparison/save', this.userBaseComparisons);
      this.$store.dispatch('comparison/setChangeStatus', true);
      this.getGraph()
    },
    selectStore (choice) {
      // 店舗リストで店舗が変更されたので、プロパティ書き換え
      this.userBaseComparisons.store_id = choice.id
      this.userBaseComparisons.store_name = choice.store_name
      // 指定店舗が変更されたので、再度APIをコールし表示データの再取得を行う
      // or
      // storeに書き込んで、再遷移？
      // 比較基準をstoreに登録
      this.$store.dispatch('comparison/save', this.userBaseComparisons);
      this.$store.dispatch('comparison/setChangeStatus', true);
      this.getGraph()
    },

    onClickFailedSample () {
      // グラフデータの取得に失敗した場合、キャプションを書き換える場合
      // データなしの設定を書き換える
      let baseChartOptions = {...this.gender.chartOptions,
        ...{
          noData: {
            text: 'データの取得に失敗しました',
            style: {
              color: '#F00'
            }
          }
        }
      }
      // グラフオプションデータの更新を通知
      this.$refs.gender.updateOptions(baseChartOptions)

      // データを空にする
      this.gender.series = []
      // グラフデータの更新を通知
      this.$refs.gender.updateSeries(this.gender.series)
    },
    /**
     * 多店舗と比較する項目を設定する共通関数
     * @param displayData
     * @param resultData
     */
    setGraphData(displayData, resultData) {
      displayData.self = resultData.display.self;
      displayData.all = resultData.display.all;
      displayData.high = resultData.display.high;
      displayData.low = resultData.display.low;
      displayData.frame_status = resultData.frame_status;
    },
    /**
     * 非同期通信の結果を返す
     * @param response
     * @returns {boolean}
     */
    checkResponse(response) {
      const result = response.data?.result || 0;
      const data = response.data?.data || null;
      return result === true && data !== null;
    },
    setIndexDBData(type,data,values,frame_status,comparison) {
      return {
        from: comparison.date_from,
        to: comparison.date_to,
        store_id: comparison.store_id,
        type: type,
        details: data,
        raw: values,
        frame_status: frame_status,
        timestamp: new Date().getTime()
      }
    },
    checkDate(statuses) {
      if (statuses.status) {
        if(statuses.deadline) {
          clearData(SAVE_STORE_SUMMARY)
          clearData(SAVE_STORE_GRAPH)
        }
        this.searchIndexedDB()
      } else {
        this.getGraph()
      }
    },
    searchIndexedDB() {
      const searchList = [
        {type: DATA_TYPES.SALES, base: this.userBaseComparisons, callback: this.setRetentionSales},
        {type: DATA_TYPES.CUSTOMER, base: this.userBaseComparisons, callback: this.setRetentionCustomer},
        {type: DATA_TYPES.UNIT_PRICE, base: this.userBaseComparisons, callback: this.setRetentionUnitPrice},
        {type: DATA_TYPES.ROTATION, base: this.userBaseComparisons, callback: this.setRetentionRotation},
        {type: DATA_TYPES.ORDER, base: this.userBaseComparisons, callback: this.setRetentionOrder},
        {type: DATA_TYPES.TAKEOUT, base: this.userBaseComparisons, callback: this.setRetentionTakeout},
        {type: DATA_TYPES.PAYMENT, base: this.userBaseComparisons, callback: this.setRetentionPayment},
        {type: DATA_TYPES.GENDER, base: this.userBaseComparisons, callback: this.setRetentionGender}
      ]
      searchList.forEach(function (obj) {
        searchStore(SAVE_STORE_GRAPH, {
          from: obj.base.date_from,
          to: obj.base.date_to,
          store_id: obj.base.store_id,
          type: obj.type,
        }, obj.callback)
      });
    },
    setRetentionSales(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? [detail.data[0]] : []
        const header = detail.header[0];
        this.setRetentionData(this.sales, data, header);
      }
    },
    setRetentionCustomer(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? [detail.data[0]] : []
        const header = detail.header[0];
        this.setRetentionData(this.customer, data, header);
      }
    },
    setRetentionUnitPrice(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? [detail.data[0]] : []
        const header = detail.header[0];
        this.setRetentionData(this.unitPrice, data, header);
      }
    },
    setRetentionRotation(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? [detail.data[0]] : []
        const header = detail.header[0];
        this.setRetentionData(this.rotation, data, header);
      }
    },
    setRetentionOrder(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? [detail.data[0]] : []
        const header = detail.header[0];
        this.setRetentionData(this.orderCount, data, header);
      }
    },
    setRetentionTakeout(detail) {
      if(detail) {
        const data = Array.isArray(detail.data) ? detail.data : []
        const header = detail.header[0];
        this.setRetentionData(this.takeout, data, header);
      }
    },
    setRetentionPayment(detail) {
      if(detail) {
        const data = Array.isArray(detail.data) ? detail.data : []
        const header = detail.header[0];
        this.setRetentionData(this.payment, data, header);
      }
    },
    setRetentionGender(detail) {
      if(detail) {
        const data = Array.isArray(detail.data) ? detail.data : []
        const header = detail.header[0];
        this.setRetentionData(this.gender, data, header);
      }
    },
    setRetentionData(displayData,resultData,header) {
      displayData.series = this.convertToChartSeries(resultData)
      displayData.frame_status = header.frame_status
    }
  },
}
</script>
<style lang="scss" scoped>
  .container {
    background-image: url(~@/assets/images/bg_comparison.svg);
    background-size: contain;
  }
  @media (min-width: 600px) {
    .container {
      background-position: 0px -0px;
    }
  }
  @media (min-width: 960px) {
    .container {
      background-position: 0px -35px;
    }
  }
  @media (min-width: 1264px) {
    .container {
      background-position: 0px -160px;
    }
  }
  @media (min-width: 1904px) {
    .container {
      background-position: 0px -300px;
    }
  }
</style>
<style lang="scss">
  .header-back-btn {
    border-top-left-radius: 0!important;
    border-bottom-left-radius: 0!important;
    border-top-right-radius: 20px!important;
    border-bottom-right-radius: 20px!important;;
    width: 80px;
    background-color: #FFF;
  }

  // apexcharts関連
  .apexcharts-menu-item.exportSVG {
    display: none!important;
  }
  .apexcharts-legend-series::after {
    content: " | ";
  }
  .apexcharts-legend-series:last-child::after{
    content: "";
  }
  .apexcharts-toolbar {
    z-index: 4!important;
  }
</style>
